/**
 * Scopenod — animations de la vitrine (blocs SiteForge siteforge/blocks/scopenod-*).
 * Importé par assets/src/main.js (module ES, donc en mode strict) : rebuilder après modification.
 *
 * Repris de la maquette « Vitrine Scopenod ». Trois modules indépendants, chacun inactif si son
 * bloc n'est pas dans la page :
 *  1. Hero multi-agents (#hero) et démo terminal / MCP épinglée au défilement (#take) ;
 *     si le bloc Commentaires suit la démo, la carte RES-02 passe du canvas à la section commentaires.
 *  2. Commentaires ancrés (#cm-stage) : démo automatique puis essai par le visiteur.
 *  3. Candidature à la bêta (#wform) : la candidature devient une carte de la liste prioritaire.
 *  4. Vidéo de démo (.vid-player) : lecteur YouTube créé au clic seulement (façon lite-youtube).
 *  5. Sections problème / fichier / pour qui ([data-scp-reveal]) : animation jouée une fois à l'arrivée à l'écran.
 *  6. Guide du cadrage ([data-scp-copy]) : bouton qui copie un bloc de texte (modèle de fiche).
 *  7. Paramètres UTM de la page lus dans l'URL (rien n'est stocké), via window.scopenodUtm().
 *  8. Consentement publicitaire (#scp-consent, seulement si activé dans Réglages > Scopenod).
 * Tout est désactivé ou figé à l'état final si « réduire les animations » est actif.
 */

;(() => {
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches
const $ = (s, r = document) => r.querySelector(s)
const sleep = (ms) => new Promise((r) => setTimeout(r, ms))
const ARROW = '<svg width="20" height="24" viewBox="0 0 18 22" aria-hidden="true"><path d="M1.5 1.5v16l4.4-4.1 3.2 7 2.6-1.1-3.1-6.8h6z" fill="var(--ac)" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/></svg>'
/* Copie purement visuelle d'un élément (cartes animées) : sans id, masquée aux lecteurs d'écran, et ses
   titres h1-h6 deviennent des <div> de même classe, pour ne pas dupliquer la structure de titres de la page. */
function visualCopy(src) {
  const copy = src.cloneNode(true)
  copy.removeAttribute('id'); copy.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'))
  copy.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((h) => {
    const d = document.createElement('div')
    for (const a of h.attributes) d.setAttribute(a.name, a.value)
    d.append(...h.childNodes)
    h.replaceWith(d)
  })
  copy.setAttribute('aria-hidden', 'true')
  return copy
}

/* ═════════════════════ HERO ═════════════════════ */
const hero = $('#hero')
const hasHero = !!(hero && $('#h-board'))
if (hasHero) {
const AG = {
  claude: { name: 'Claude', color: getComputedStyle(document.documentElement).getPropertyValue('--sc-claude').trim() },
  codex: { name: 'Codex', color: '#1b1b1e' },
  ui: { name: 'Agent UI', color: '#8e51ff' },
}
const FINAL = {
  main: $('#h-main').textContent,
  sub: $('#h-sub').textContent,
}

const cursors = {}
for (const [k, a] of Object.entries(AG)) {
  const c = document.createElement('div')
  c.className = 'cursor hide'
  c.style.setProperty('--ac', a.color)
  c.innerHTML = ARROW + `<span class="tag">${a.name} <em></em></span>`
  hero.appendChild(c)
  cursors[k] = c
}
let heroRun = 0
const alive = (tok) => { if (tok !== heroRun) throw 'stop' }

function place(c, el, fx = 0.5, fy = 0.5, ms = 800, dx = 0, dy = 0) {
  const h = hero.getBoundingClientRect()
  const r = el.getBoundingClientRect()
  const x = r.left - h.left + r.width * fx + dx
  const y = r.top - h.top + r.height * fy + dy
  c.dataset.rest = JSON.stringify({ id: el.id, fx, fy, dx, dy })
  c.style.transitionDuration = ms + 'ms'
  c.style.transform = `translate(${x}px, ${y}px)`
  if (!ms) c.getBoundingClientRect()
  c.classList.remove('hide')
  return sleep(ms)
}
const say = (c, t) => { c.querySelector('em').textContent = t ? '· ' + t : '' }
function editing(el, ag, on) { el.style.setProperty('--ac', AG[ag].color); el.classList.toggle('editing', on) }

async function typeInto(el, text, tok, speed = 38) {
  const caret = document.createElement('span'); caret.className = 'caret'
  const node = document.createTextNode('')
  el.append(node, caret)
  for (const ch of text) { alive(tok); node.data += ch; await sleep(speed + Math.random() * speed * 0.8) }
  caret.remove()
}

/* Le texte du hero est FIXE (SEO, lisibilité). Les curseurs parcourent toute la section (ils « lisent » le hero),
   mais n'éditent que l'aperçu (cadrage d'une appli de rencontre) : Claude crée MSG-01, Codex fait avancer SWP-01,
   Agent UI livre MAT-01. */
const setSt = (el, cls, txt) => { el.className = 'status ' + cls; el.textContent = txt }
const steps = () => [...document.querySelectorAll('#c2steps li')]
function resetHero() {
  $('#c3').classList.add('askew')
  for (const id of ['l1', 'l2', 'l3']) $('#' + id).classList.add('off')
  setSt($('#c2s'), 'st-idee', 'Idée'); steps().forEach((li) => li.classList.remove('ok'))
  setSt($('#c3s'), 'st-dev', 'En développement')
  $('#c4').classList.add('ghost'); $('#c4t').textContent = ''
  $('#h-log').innerHTML = ''
  document.querySelectorAll('.card.writing').forEach((e) => e.classList.remove('writing'))
}
function finalHero() {
  $('#c3').classList.remove('askew')
  for (const id of ['l1', 'l2', 'l3']) $('#' + id).classList.remove('off')
  setSt($('#c2s'), 'st-recette', 'En recette'); steps().forEach((li) => li.classList.add('ok'))
  setSt($('#c3s'), 'st-prod', 'En production')
  $('#c4').classList.remove('ghost'); $('#c4t').textContent = 'Messagerie après un match'
}
function writing(el, ag, on) { el.style.setProperty('--ac', AG[ag].color); el.classList.toggle('writing', on) }
async function drawLink(id, tok) { const l = $('#' + id); l.classList.remove('off'); l.classList.add('hot'); await sleep(750); alive(tok); l.classList.remove('hot') }

async function claudeSeq(tok) {
  const c = cursors.claude
  await sleep(300); alive(tok)
  if (c.classList.contains('hide')) await place(c, $('#h-main'), 0.05, 0.1, 0, -30, -20)
  say(c, 'lecture du cadrage')
  await place(c, $('#h-main'), 0.55, 0.45, 1300); alive(tok)
  await place(c, $('#h-sub'), 0.8, 0.6, 1000); alive(tok)
  say(c, 'create-feature MSG-01')
  await place(c, $('#c4'), 0.3, 0.3, 1100); alive(tok)
  const c4 = $('#c4'); writing(c4, 'claude', true); c4.classList.remove('ghost')
  await sleep(400); alive(tok)
  const t = $('#c4t'); t.style.setProperty('--ac', AG.claude.color)
  await typeInto(t, 'Messagerie après un match', tok, 34)
  say(c, 'lien MAT-01 → MSG-01')
  await place(c, $('#l3'), 0.5, 0.5, 600); alive(tok)
  await drawLink('l3', tok)
  writing(c4, 'claude', false)
  say(c, 'terminé')
  await place(c, $('#c4'), 1, 1, 900, 24, 14)
}
async function codexSeq(tok) {
  const c = cursors.codex
  await sleep(1100); alive(tok)
  if (c.classList.contains('hide')) await place(c, $('#h-form'), 0, 1, 0, -20, 30)
  say(c, 'relecture des specs')
  await place(c, $('#h-form'), 0.9, 0.5, 1100); alive(tok)
  await place(c, $('#s-title'), 0.35, 0.2, 1000); alive(tok)
  say(c, 'SWP-01 · critères')
  const c2 = $('#c2')
  await place(c, steps()[0], 0.04, 0.5, 1100); alive(tok)
  writing(c2, 'codex', true)
  steps()[0].classList.add('ok'); await sleep(450); alive(tok)
  await place(c, steps()[1], 0.04, 0.5, 450); alive(tok)
  steps()[1].classList.add('ok'); await sleep(400); alive(tok)
  say(c, 'SWP-01 → En recette')
  await place(c, $('#c2s'), 0.5, 0.6, 700); alive(tok)
  setSt($('#c2s'), 'st-recette', 'En recette')
  await sleep(300); alive(tok)
  await place(c, $('#l1'), 0.5, 0.5, 500); alive(tok)
  await drawLink('l1', tok)
  writing(c2, 'codex', false)
  say(c, 'terminé')
  await place(c, $('#c2'), 1, 0.5, 800, 28, 0)
}
async function uiSeq(tok) {
  const c = cursors.ui
  await sleep(2000); alive(tok)
  if (c.classList.contains('hide')) await place(c, $('#h-board'), 1, 0, 0, 20, -30)
  say(c, 'revue des cartes')
  await place(c, $('#h-badge'), 1, 0.5, 1100, 60, 0); alive(tok)
  say(c, 'alignement MAT-01')
  await place(c, $('#c3'), 0.5, 0.15, 1100); alive(tok)
  const c3 = $('#c3'); writing(c3, 'ui', true); c3.classList.remove('askew')
  await place(c, $('#c3'), 0.45, 0.2, 900, -38, -10); alive(tok)
  say(c, 'MAT-01 → En production')
  await place(c, $('#c3s'), 0.5, 0.6, 700); alive(tok)
  setSt($('#c3s'), 'st-prod', 'En production')
  await place(c, $('#l2'), 0.5, 0.5, 500); alive(tok)
  await drawLink('l2', tok)
  writing(c3, 'ui', false)
  say(c, 'terminé')
  await place(c, $('#c3'), 1, 1, 800, 26, 16)
}

/* Retour à l'état de départ : les mêmes agents défont leur travail dans le cadre (le texte n'est jamais touché). */
async function claudeBack(tok) {
  const c = cursors.claude, c4 = $('#c4')
  say(c, 'suppression de MSG-01')
  await place(c, c4, 0.3, 0.3, 900); alive(tok)
  writing(c4, 'claude', true)
  await sleep(500); alive(tok)
  $('#l3').classList.add('off')
  c4.classList.add('ghost')
  await sleep(500); alive(tok)
  writing(c4, 'claude', false); $('#c4t').textContent = ''
  say(c, 'en attente')
  await place(c, $('#h-main'), 0.9, 0.2, 1200, 30, 0)
}
async function codexBack(tok) {
  const c = cursors.codex, c2 = $('#c2')
  await sleep(700); alive(tok)
  say(c, 'SWP-01 → Idée')
  await place(c, $('#c2s'), 0.5, 0.6, 900); alive(tok)
  writing(c2, 'codex', true)
  setSt($('#c2s'), 'st-idee', 'Idée')
  await sleep(350); alive(tok)
  await place(c, steps()[1], 0.04, 0.5, 600); alive(tok)
  steps()[1].classList.remove('ok'); await sleep(300); alive(tok)
  await place(c, steps()[0], 0.04, 0.5, 400); alive(tok)
  steps()[0].classList.remove('ok'); await sleep(300); alive(tok)
  $('#l1').classList.add('off')
  writing(c2, 'codex', false)
  say(c, 'en attente')
  await place(c, $('#h-form'), 0.9, 0.5, 1200, 20, 30)
}
async function uiBack(tok) {
  const c = cursors.ui, c3 = $('#c3')
  await sleep(1400); alive(tok)
  say(c, 'MAT-01 → En développement')
  await place(c, $('#c3s'), 0.5, 0.6, 900); alive(tok)
  writing(c3, 'ui', true)
  setSt($('#c3s'), 'st-dev', 'En développement')
  $('#l2').classList.add('off')
  await sleep(350); alive(tok)
  await place(c, c3, 0.45, 0.2, 700, -38, -10); alive(tok)
  c3.classList.add('askew')
  await place(c, c3, 0.5, 0.15, 900); alive(tok)
  writing(c3, 'ui', false)
  say(c, 'en attente')
  await place(c, $('#h-board'), 1, 0, 1000, 20, -30)
}

const waitVisible = async (tok) => { while (!heroVisible) { alive(tok); await sleep(300) } alive(tok) }
const who = () => Object.values(AG).map((a) => `<span class="who"><i style="background:${a.color}"></i>${a.name}</span>`).join('')

async function playHero() {
  const tok = ++heroRun
  if (reduce) {
    finalHero()
    await place(cursors.claude, $('#c4'), 1, 1, 0, 24, 14)
    await place(cursors.codex, $('#c2'), 1, 0.5, 0, 28, 0)
    await place(cursors.ui, $('#c3'), 1, 1, 0, 26, 16)
    for (const c of Object.values(cursors)) say(c, '')
    return
  }
  resetHero()
  for (const c of Object.values(cursors)) c.classList.add('hide')
  try {
    // Boucle : les agents construisent le hero, puis le remettent eux-mêmes au brouillon, et recommencent.
    for (;;) {
      const t0 = performance.now()
      $('#h-log').innerHTML = who() + '<span>· en cours…</span>'
      await Promise.all([claudeSeq(tok), codexSeq(tok), uiSeq(tok)])
      const sec = ((performance.now() - t0) / 1000).toFixed(0)
      $('#h-log').innerHTML = who() + `<span>· 10 modifications en ${sec} s</span>`
      await sleep(4200); await waitVisible(tok)
      $('#h-log').innerHTML = who() + '<span>· retour à l’état de départ…</span>'
      await Promise.all([claudeBack(tok), codexBack(tok), uiBack(tok)])
      $('#h-log').innerHTML = who() + '<span>· état de départ rétabli</span>'
      await sleep(1600); await waitVisible(tok)
    }
  } catch (e) { if (e !== 'stop') throw e }
}
let heroVisible = true
new IntersectionObserver(([e]) => (heroVisible = e.isIntersecting), { threshold: 0.25 }).observe(hero)

addEventListener('resize', () => {
  for (const c of Object.values(cursors)) {
    if (!c.dataset.rest) continue
    const r = JSON.parse(c.dataset.rest)
    const el = document.getElementById(r.id); if (!el) continue
    place(c, el, r.fx, r.fy, 0, r.dx, r.dy)
  }
})

playHero()
} // fin HERO

/* ═════════════════════ DÉMO TERMINAL / MCP ═════════════════════
   Un seul terminal : la petite fenêtre du départ EST le terminal plein écran, qui s'agrandit
   (position et taille) en fonction du défilement, de façon continue et réversible. Épinglage court.
   Le scénario (terminal + canvas de l'app) avance dans le temps, indépendamment du défilement :
   il démarre à l'arrivée de la section à l'écran et ne repart jamais de zéro en défilant.
   Ensuite, la carte RES-02 sort du canvas et devient la carte de la section commentaires. */
const take = $('#take')
if (take) {
const dark = $('#dark'), stage = $('#stage'), tbody = $('#tbody')
const sticky = take.querySelector('.take-sticky'), head = $('#take-head'), hint = $('#take-hint')
// Unité d'écran figée en px au chargement : ouvrir le clavier (qui réduit la fenêtre) ne change plus la hauteur
// de la section, donc la page ne saute plus. Recalculée seulement si la LARGEUR change (rotation).
let vhW = innerWidth
const setVh = () => document.documentElement.style.setProperty('--vh0', innerHeight / 100 + 'px')
setVh()
addEventListener('resize', () => { if (innerWidth !== vhW) { vhW = innerWidth; setVh() } })
// Découpage de l'épinglage (fraction de la course, 200 % d'écran) : agrandissement (≈ 50 % d'écran),
// plein écran (≈ 60 %), puis transition de carte (A : le terminal se replie, B : zoom sur RES-02,
// C : la carte rejoint la section commentaires).
const GROW = 0.25, P_A = 0.55, P_B = 0.68, P_C = 0.82
let k = 0, visible = false, started = false, inX = false, xferSent = false

function rectSize() {
  const vw = innerWidth, vh = sticky.clientHeight
  return { vw, vh, w0: Math.min(620, vw - 32), h0: Math.min(300, vh * 0.38) }
}
// La petite fenêtre est décalée vers le bas pour laisser l'en-tête au-dessus.
let oy = 0
function layoutTake() {
  const { vh, h0 } = rectSize()
  const hh = head.offsetHeight, base = (vh - h0) / 2
  oy = Math.max(0, Math.min(76 + hh + 40 - base, base - 56))
  head.style.top = Math.max(64, base + oy - hh - 40) + 'px'
}
/** Taille et position du terminal pour un avancement k (0 = petite fenêtre, 1 = plein écran). */
function setGrow(kk) {
  k = kk
  const { vw, vh, w0, h0 } = rectSize()
  const w = w0 + (vw - w0) * k, h = h0 + (vh - h0) * k
  Object.assign(dark.style, { left: (vw - w) / 2 + 'px', top: (vh - h) / 2 + oy * (1 - k) + 'px', width: w + 'px', height: h + 'px', borderRadius: 14 * (1 - k) + 'px' })
  dark.style.setProperty('--k', k)
  // La fenêtre de l'app ne s'ouvre qu'en plein écran (elle se referme en rétrécissant) ; son contenu suit le scénario.
  dark.classList.toggle('compact', k < 0.97)
  head.style.opacity = Math.max(0, 1 - k * 2.4); head.style.transform = `translateY(${-k * 50}px)`
  if (hint) hint.style.opacity = Math.max(0, 1 - k * 4)
}
const ease = (t) => 1 - Math.pow(1 - t, 3)
function progress() {
  const range = take.offsetHeight - sticky.clientHeight
  return Math.min(1, Math.max(0, (scrollY - take.offsetTop) / range))
}
function onScroll() {
  if (reduce) return
  const p = progress()
  setGrow(ease(Math.min(1, p / GROW)))
  document.body.classList.toggle('immersive', k >= 1 && p < 0.995)
  xfer(p)
}
layoutTake()
addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true })
addEventListener('resize', () => { layoutTake(); onScroll() })
// la hauteur de l'en-tête change quand les polices arrivent : on recale
document.fonts?.ready.then(() => { layoutTake(); onScroll() })
new ResizeObserver(() => { layoutTake(); onScroll() }).observe(head)

/* --- scénario terminal + canvas --- */
const MODS = [
  { id: 'm0', name: 'Réservation', x: 20 },
  { id: 'm1', name: 'Abonnement', x: 350 },
  { id: 'm2', name: 'Espace coach', x: 680 },
]
const CARDS = {
  'RES-01': { m: 0, y: 62, t: 'Planning des cours' },
  'RES-02': { m: 0, y: 166, h: 110, t: 'Réserver une place' }, // présente dès le départ (voir baseCanvas)
  'RES-03': { m: 0, y: 292, t: 'Liste d’attente' },
  'ABO-01': { m: 1, y: 62, t: 'Choisir une formule' },
  'ABO-02': { m: 1, y: 170, t: 'Paiement récurrent' },
  'COA-01': { m: 2, y: 62, t: 'Gérer ses créneaux' },
  'COA-02': { m: 2, y: 170, t: 'Voir les inscrits' },
}
const cardBox = (code) => { const c = CARDS[code]; return { x: MODS[c.m].x + 20, y: c.y, w: 260, h: c.h || 82 } }

const SCRIPT = [
  { k: 'user', t: 'Cadre-moi FitBook : une app de réservation de cours pour une salle de sport. Réservation, abonnements, espace coach.' },
  { k: 'think', ms: 900 },
  { k: 'say', t: 'Je choisis d’abord le projet visé.' },
  { k: 'tool', n: 'list_projects', a: '', r: [['3 projets · FitBook (1 fonctionnalité)']] },
  { k: 'tool', n: 'select_project', a: '"FitBook"', r: [['Session rattachée à FitBook.scopenod']] },
  { k: 'say', t: 'FitBook contient déjà RES-02 « Réserver une place ». Je complète : Réservation, Abonnement, Espace coach.' },
  { k: 'tool', n: 'apply_ops', a: '3 opérations', r: [
    ['<span class="add">+</span> RES-01 Planning des cours', { card: 'RES-01' }],
    ['<span class="add">+</span> RES-03 Liste d’attente', { card: 'RES-03' }],
    ['<span class="add">+</span> lien RES-02 → RES-01', { edge: ['RES-02', 'RES-01'] }],
  ] },
  { k: 'tool', n: 'apply_ops', a: '6 opérations', r: [
    ['<span class="add">+</span> module Abonnement', { mod: 1 }],
    ['<span class="add">+</span> ABO-01 Choisir une formule', { card: 'ABO-01' }],
    ['<span class="add">+</span> ABO-02 Paiement récurrent', { card: 'ABO-02' }],
    ['<span class="add">+</span> lien RES-02 → ABO-01', { edge: ['RES-02', 'ABO-01'] }],
  ] },
  { k: 'tool', n: 'apply_ops', a: '5 opérations', r: [
    ['<span class="add">+</span> module Espace coach', { mod: 2 }],
    ['<span class="add">+</span> COA-01 Gérer ses créneaux', { card: 'COA-01' }],
    ['<span class="add">+</span> COA-02 Voir les inscrits', { card: 'COA-02' }],
    ['<span class="add">+</span> lien COA-01 → RES-01', { edge: ['COA-01', 'RES-01'] }],
  ] },
  { k: 'tool', n: 'apply_ops', a: '2 opérations', r: [
    ['<span class="add">+</span> doc « Parcours de réservation »', { doc: true }],
    ['<span class="q">?</span> ABO-02 : Stripe ou paiement sur place ?', { ask: 'ABO-02' }],
  ] },
  { k: 'done', t: 'Cadrage prêt : 3 modules, 7 fonctionnalités, 1 document. Une question t’attend sur ABO-02.' },
]
const STYLE = {
  claude: {
    color: getComputedStyle(document.documentElement).getPropertyValue('--sc-claude').trim(), cursor: getComputedStyle(document.documentElement).getPropertyValue('--sc-claude').trim(), name: 'Claude',
    banner: '<b>✻</b> Claude Code · serveur MCP <b>scopenod</b> connecté',
    tool: (n, a) => `<span class="mk">●</span> <span class="tool">scopenod · ${n}</span><span class="args">(${a})</span>`,
    res: (h) => `<span class="dim">⎿</span> ${h}`,
    think: 'Réflexion…', mark: '● ',
  },
  codex: {
    color: '#7dd3fc', cursor: '#1b1b1e', name: 'Codex',
    banner: '<b>›_</b> Codex · MCP : <b>scopenod</b> (connecté)',
    tool: (n, a) => `<span class="mk">•</span> Called <span class="tool">scopenod.${n}</span><span class="args">({${a ? ' ' + a + ' ' : ''}})</span>`,
    res: (h) => `<span class="dim">└</span> ${h}`,
    think: 'Working…', mark: '• ',
  },
}
let run = 0, current = 'claude'
const live = (tok) => { if (tok !== run) throw 'stop' }
const dly = (ms, tok) => sleep(reduce ? 0 : ms).then(() => live(tok))

function line(cls, html) {
  const d = document.createElement('div')
  d.className = 'ln ' + cls
  d.innerHTML = html
  tbody.appendChild(d)
  tbody.scrollTop = tbody.scrollHeight
  return d
}
async function stream(el, text, tok, speed) {
  const n = document.createTextNode(''); el.appendChild(n)
  if (reduce) { n.data = text; return }
  const words = text.split(/(\s+)/)
  for (const w of words) { n.data += w; tbody.scrollTop = tbody.scrollHeight; await dly(speed, tok) }
}

/* canvas */
const cstage = $('#cstage'), edges = $('#edges'), ccur = $('#ccursor'), vp = $('#viewport')
let base = { s: 1, tx: -500, ty: -200 }
function fitStage() {
  const w = vp.clientWidth, h = vp.clientHeight
  if (!w || !h) return
  const s = Math.min(w / 1000, h / 490)
  base = { s, tx: -500 * s, ty: -200 * s }
  if (!inX) cstage.style.transform = `translate(${base.tx}px, ${base.ty}px) scale(${s})`
}
new ResizeObserver(fitStage).observe(vp)
/* État de base du graphe, jamais effacé : le module Réservation et la carte RES-02. RES-02 est une copie
   de la carte de la section commentaires (même largeur réelle, réduite à l'échelle du canvas, coupée à la
   même hauteur, même dégradé) : au moment de la transition, la carte volante la recouvre au pixel près. */
const cmCardSrc = $('#cm-card')
let resCard = null
function syncResCard() {
  if (!resCard || !cmCardSrc) return
  const w = cmCardSrc.offsetWidth; if (!w) return
  const box = cardBox('RES-02'), sc = box.w / w
  const inner = visualCopy(cmCardSrc)
  inner.classList.add('fly', 'res-copy')
  Object.assign(inner.style, { opacity: '', left: '0px', top: '0px', width: w + 'px', height: box.h / sc + 'px', transformOrigin: '0 0', transform: `scale(${sc})` })
  resCard.replaceChildren(inner)
}
function baseCanvas() {
  const m0 = makeMod(0); m0.classList.add('on', 'base'); m0.querySelector('.n').textContent = '1'
  const b = cardBox('RES-02')
  resCard = document.createElement('div'); resCard.className = 'ccard res-card on base'; resCard.id = 'cc-RES-02'
  Object.assign(resCard.style, { left: b.x + 'px', top: b.y + 'px', height: b.h + 'px' })
  cstage.insertBefore(resCard, ccur)
  if (cmCardSrc) syncResCard()
  else resCard.innerHTML = '<div class="row"><span class="lot">L1</span><span class="code">RES-02</span></div><div class="t">Réserver une place</div>'
}
addEventListener('resize', syncResCard)
function resetCanvas() {
  cstage.querySelectorAll('.mod:not(.base), .ccard:not(.base)').forEach((e) => e.remove())
  const n0 = $('#m0 .n'); if (n0) n0.textContent = '1'
  edges.innerHTML = ''
  $('#docchip').classList.remove('on')
  // Fenêtre de l'app ouverte dès le plein écran : le curseur de l'agent attend au centre du canvas.
  ccur.classList.add('waiting')
  ccur.style.transition = 'none'; ccur.style.transform = 'translate(500px, 210px)'
  requestAnimationFrame(() => (ccur.style.transition = ''))
}
function moveCursor(x, y) { ccur.style.transform = `translate(${x}px, ${y}px)`; return sleep(reduce ? 0 : 700) }
function makeMod(i) {
  const m = MODS[i]
  const el = document.createElement('div'); el.className = 'mod'; el.id = m.id
  el.style.left = m.x + 'px'
  el.innerHTML = `<header><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>${m.name}<span class="n">0</span></header>`
  cstage.insertBefore(el, ccur)
  return el
}
function makeCard(code) {
  const b = cardBox(code)
  const el = document.createElement('div'); el.className = 'ccard'; el.id = 'cc-' + code
  el.style.left = b.x + 'px'; el.style.top = b.y + 'px'
  el.innerHTML = `<div class="row"><span class="lot">L1</span><span class="code">${code}</span><span class="est">estimer</span></div><div class="t"></div><div class="f">Suivi de cadrage <span class="status st-idee">Idée</span></div><span class="ask">À cadrer</span>`
  cstage.insertBefore(el, ccur)
  return el
}
function edgePath(s, t) {
  const a = cardBox(s), b = cardBox(t)
  if (CARDS[s].m === CARDS[t].m) return `M${a.x + 130} ${a.y} L${b.x + 130} ${b.y + b.h}`
  if (Math.abs(CARDS[s].m - CARDS[t].m) === 1) {
    const sx = a.x + (b.x > a.x ? a.w : 0), tx = b.x + (b.x > a.x ? 0 : b.w)
    return `M${sx} ${a.y + a.h / 2} C${(sx + tx) / 2} ${a.y + a.h / 2} ${(sx + tx) / 2} ${b.y + b.h / 2} ${tx} ${b.y + b.h / 2}`
  }
  return `M${a.x + 130} ${a.y} C${a.x + 130} ${-40} ${b.x + 130} ${-40} ${b.x + 130} ${b.y}`
}
const bump = (code) => { const n = $('#' + MODS[CARDS[code].m].id + ' .n'); n.textContent = +n.textContent + 1 }
async function canvasAct(act, tok) {
  if (ccur.classList.contains('waiting')) { ccur.classList.remove('waiting'); $('#ctag').textContent = STYLE[current].name + ' · Édition…' }
  if ('mod' in act) {
    const m = MODS[act.mod]
    const el = makeMod(act.mod)
    await moveCursor(m.x + 120, 24); live(tok)
    el.classList.add('on')
  } else if (act.card) {
    const b = cardBox(act.card)
    await moveCursor(b.x + 150, b.y + 30); live(tok)
    const el = makeCard(act.card); el.classList.add('writing')
    requestAnimationFrame(() => el.classList.add('on'))
    const t = el.querySelector('.t')
    for (const ch of CARDS[act.card].t) { t.textContent += ch; await dly(18, tok) }
    bump(act.card)
    await dly(120, tok); el.classList.remove('writing')
  } else if (act.edge) {
    const a = cardBox(act.edge[0])
    await moveCursor(a.x + 130, a.y + 10); live(tok)
    const p = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    p.setAttribute('d', edgePath(...act.edge)); edges.appendChild(p)
    const L = p.getTotalLength()
    p.style.strokeDasharray = `${L}`; p.style.strokeDashoffset = `${L}`
    p.getBoundingClientRect()
    p.style.transition = reduce ? 'none' : 'stroke-dashoffset .8s cubic-bezier(.4,0,.2,1)'
    p.style.strokeDashoffset = '0'
    await dly(820, tok)
    p.style.transition = 'none'; p.style.strokeDasharray = '5 5'
  } else if (act.doc) {
    await moveCursor(840, 390); live(tok)
    $('#docchip').classList.add('on')
  } else if (act.ask) {
    const b = cardBox(act.ask)
    await moveCursor(b.x + b.w - 10, b.y + 4); live(tok)
    $('#cc-' + act.ask + ' .ask').classList.add('on')
  }
}

/* ─── Transition vers les commentaires (liée au scroll, réversible) ───
   A : le terminal se replie, la fenêtre de l'app prend tout l'écran.
   B : la caméra zoome sur RES-02 (les autres nœuds s'effacent) jusqu'à la place exacte de la carte commentée.
   C : la carte se déplie (sa description apparaît), l'app s'efface et révèle la section commentaires en dessous. */
const cmSec = $('#comments'), cmCard = $('#cm-card'), app = $('#app')
const c01 = (x) => Math.min(1, Math.max(0, x))
const smooth = (x) => x * x * (3 - 2 * x)
let fly = null
function enterX() {
  // Le scénario continue : RES-02 est toujours dans le graphe, la transition peut partir à tout moment.
  inX = true
  syncResCard()
  $('#handoff').classList.remove('on')
  stage.classList.add('xfer'); cstage.classList.add('xfer'); take.classList.add('xfer-on')
}
function leaveX() {
  inX = false
  stage.classList.remove('xfer'); cstage.classList.remove('xfer'); take.classList.remove('xfer-on')
  stage.style.removeProperty('--a'); cstage.style.removeProperty('--b')
  dark.style.background = ''; app.style.opacity = ''
  const card = $('#cc-RES-02'); if (card) card.style.opacity = ''
  if (fly) { fly.remove(); fly = null }
  cmCard.style.opacity = ''; sticky.style.pointerEvents = ''
  delete document.body.dataset.xfer
  fitStage()
  // Le scénario n'a pas été interrompu : rien à relancer (le relais Claude ↔ Codex attend la fin de l'agent).
}
function xfer(p) {
  if (!cmSec || !cmCard) return
  if (k < 1 || p < P_A) { if (inX) leaveX(); return }
  if (!inX) enterX()
  const a = smooth(c01((p - P_A) / (P_B - P_A)))
  const b = smooth(c01((p - P_B) / (P_C - P_B)))
  const c = c01((p - P_C) / ((1 - P_C) * 0.96))
  stage.style.setProperty('--a', a)
  dark.style.background = a >= 1 ? 'transparent' : ''
  fitStage()
  const card = $('#cc-RES-02'); if (!card) return
  // Place finale de la carte commentée : quand la section arrive en haut (fin de l'épinglage).
  const sr = sticky.getBoundingClientRect(), cr = cmCard.getBoundingClientRect(), mr = cmSec.getBoundingClientRect(), vr = vp.getBoundingClientRect()
  const F = { x: cr.left - sr.left, y: cr.top - mr.top, w: cr.width, h: cr.height }
  const B = cardBox('RES-02'), s2 = F.w / B.w
  const tx2 = sr.left + F.x - vr.left - vr.width / 2 - B.x * s2
  const ty2 = sr.top + F.y - vr.top - vr.height / 2 - B.y * s2
  const sc = base.s + (s2 - base.s) * b
  cstage.style.transform = `translate(${base.tx + (tx2 - base.tx) * b}px, ${base.ty + (ty2 - base.ty) * b}px) scale(${sc})`
  cstage.style.setProperty('--b', b)
  // La vraie carte (clone de la carte commentée) remplace la carte du canvas DÈS le début du zoom, quand elle est
  // encore petite à l'écran : l'échange ne se voit pas. Ensuite elle suit exactement le cadre de la carte du canvas
  // (même position, mise à l'échelle), puis se déplie en C. Plus de fondu entre deux cartes de mise en page différente.
  if (b > 0) {
    if (!fly) {
      fly = visualCopy(cmCard)
      fly.classList.add('fly')
      sticky.appendChild(fly)
    }
    const r = card.getBoundingClientRect()
    const k = r.width / F.w
    const compact = r.height / k
    const hFull = card.offsetHeight * s2
    const h = c > 0 ? hFull + (F.h - hFull) * smooth(c) : compact
    const swap = c01(b / 0.12)
    Object.assign(fly.style, { left: r.left - sr.left + 'px', top: r.top - sr.top + 'px', width: F.w + 'px', height: h + 'px', transformOrigin: '0 0', transform: `scale(${k})`, opacity: swap })
    card.style.opacity = 1 - swap
    fly.style.setProperty('--fade', 1 - smooth(c01((c - 0.82) / 0.16)))
    app.style.opacity = c > 0 ? 1 - smooth(c01((c - 0.5) / 0.46)) : ''
  } else {
    if (fly) { fly.remove(); fly = null }
    card.style.opacity = ''; app.style.opacity = ''
  }
  const done = p >= 0.995
  cmCard.style.opacity = done ? '' : '0'
  if (fly) fly.style.visibility = done ? 'hidden' : ''
  sticky.style.pointerEvents = c > 0.5 ? 'none' : ''
  if (done) { delete document.body.dataset.xfer; if (!xferSent) { xferSent = true; dispatchEvent(new Event('xfer-done')) } }
  else { document.body.dataset.xfer = '1'; xferSent = false }
}

async function runAgent(agent, chain) {
  const tok = ++run
  current = agent
  const S = STYLE[agent]
  document.querySelectorAll('#take .tab').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.agent === agent)))
  tbody.innerHTML = ''
  tbody.style.setProperty('--ac', S.color)
  stage.style.setProperty('--ac', S.cursor)
  $('#app-agents').style.setProperty('--ac', S.cursor)
  $('#app-agent-name').textContent = S.name
  $('#ctag').textContent = S.name + ' · en attente'
  $('#handoff').classList.remove('on')
  resetCanvas()
  try {
    const cmd = line('dim', '<span style="color:var(--sc-dark-ink)">$</span> ')
    await stream(cmd, agent, tok, 90)
    await dly(350, tok)
    line('banner', S.banner)
    for (const st of SCRIPT) {
      if (st.k === 'user') {
        const d = line('user', '<span class="pr">›</span>')
        await dly(250, tok)
        const n = document.createTextNode(''); d.appendChild(n)
        const car = document.createElement('span'); car.className = 'caret'; d.appendChild(car)
        if (reduce) n.data = st.t
        else for (const ch of st.t) { n.data += ch; await dly(18, tok) }
        await dly(300, tok)
        car.remove()
      } else if (st.k === 'think') {
        const d = line('dim spin', S.think); await dly(st.ms, tok); d.remove()
      } else if (st.k === 'say') {
        const d = line('say', `<span style="color:${S.color}">${S.mark}</span>`)
        await stream(d, st.t, tok, 45); await dly(250, tok)
      } else if (st.k === 'tool') {
        const d = line('', S.tool(st.n, st.a)); d.classList.add('spin')
        await dly(550, tok); d.classList.remove('spin')
        for (const [html, act] of st.r) {
          line('res', S.res(html))
          if (act) await canvasAct(act, tok)
          else await dly(220, tok)
        }
        await dly(250, tok)
      } else if (st.k === 'done') {
        line('done', '✓ ' + st.t)
      }
    }
    $('#ctag').textContent = S.name + ' · terminé'
    await moveCursor(900, 330)
    if (chain && !reduce) handoffLater()
  } catch (e) { if (e !== 'stop') throw e }
}
document.querySelectorAll('#take .tab').forEach((t) => t.addEventListener('click', () => runAgent(t.dataset.agent, true)))

/** Passage de relais Claude ↔ Codex, seulement quand la démo est à l'écran et hors transition. */
let handoffTok = 0
async function handoffLater() {
  if (reduce) return
  const tok = ++handoffTok, other = current === 'claude' ? 'codex' : 'claude'
  const wait = async (ms) => { await sleep(ms); if (tok !== handoffTok) throw 'stop' }
  try {
    await wait(1800)
    while (!visible || inX) await wait(300)
    $('#handoff').textContent = `Même serveur MCP, autre agent : au tour de ${STYLE[other].name}`
    $('#handoff').classList.add('on')
    await wait(2400)
    while (!visible || inX) await wait(300)
    runAgent(other, true)
  } catch (e) { if (e !== 'stop') throw e }
}

/* ─── démarrage : le scénario commence quand la section arrive à l'écran ─── */
baseCanvas()
new IntersectionObserver(([e]) => {
  visible = e.isIntersecting
  if (visible && !started && !inX) { started = true; runAgent('claude', !reduce) }
}, { threshold: 0.4 }).observe(sticky)
if (reduce) dark.style.setProperty('--k', 1)
else onScroll()
} // fin TAKEOVER
})()

/* ═════════════ COMMENTAIRES : démo à l'arrivée, puis le visiteur essaie ═════════════ */
;(() => {
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches
const $ = (s) => document.querySelector(s)
const sleep = (ms) => new Promise((r) => setTimeout(r, reduce ? 0 : ms))
const stage = $('#cm-stage')
if (!stage) return
const desc = $('#cm-desc'), list = $('#cm-list'), composer = $('#cm-composer')
const input = $('#cm-input'), send = $('#cm-send'), fc = $('#cm-forclaude'), fcur = $('#cm-cursor'), note = $('#cm-note')
const threads = []
let pending = null, demoTok = 0, demoOn = false, replyIx = 0
const coarse = matchMedia('(pointer: coarse)').matches

/* Réponses génériques de Claude (+ l'action qu'il applique), tirées à tour de rôle. */
const REPLIES = [
  ['Bonne remarque. J’ajoute un critère d’acceptation sur ce point et je le cite dans la doc « Parcours de réservation ».', 'apply_ops · set-content RES-02 · + 1 critère'],
  ['C’est une décision produit : je la pose en question de cadrage sur RES-02, à trancher dans l’app.', 'apply_ops · add-question RES-02'],
  ['C’est lié à la liste d’attente (RES-03). J’ajoute la dépendance pour qu’elle soit visible sur le graphe.', 'apply_ops · link RES-02 → RES-03'],
  ['Je reformule ce passage pour lever l’ambiguïté et je passe la carte en « Cadrée ».', 'apply_ops · set-content · set-status cadree'],
  ['Hors périmètre V1 à mon avis : je crée une fonctionnalité séparée en lot 2, reliée à celle-ci.', 'apply_ops · create-feature RES-06 (L2)'],
  ['Déjà géré côté serveur, mais ce n’était pas écrit : je complète la description et j’ajoute un test manuel.', 'apply_ops · set-content · create-test'],
  ['D’accord. Je mets à jour la règle et je te laisse valider dans la Vue Test une fois développé.', 'apply_ops · set-content · create-test'],
]
const USER_DEMO = '@Claude notification push ou email ?'
const CLAUDE_DEMO = ['Les deux : push par défaut, email en secours si les notifications sont coupées. Je précise la règle et j’ajoute un test manuel.', 'apply_ops · set-content RES-02 · create-test']

const rel = (r) => { const s = stage.getBoundingClientRect(); return { x: r.left - s.left, y: r.top - s.top, w: r.width, h: r.height } }
const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c])

function clampRange(r) {
  // Une bulle = un passage dans UNE ligne de texte (pas à cheval sur deux éléments), hors passage déjà commenté.
  if (r.startContainer.nodeType !== 3) return null
  if (r.startContainer.parentElement.closest('.cmt-hl')) return null
  if (r.endContainer !== r.startContainer) r.setEnd(r.startContainer, r.startContainer.length)
  if (r.toString().trim().length < 2) return null
  return r
}
function openComposer(range, focus = true) {
  pending = range.cloneRange()
  const q = range.toString().trim()
  $('#cm-quote').textContent = '« ' + (q.length > 90 ? q.slice(0, 90) + '…' : q) + ' »'
  input.value = ''; send.disabled = true; fc.checked = true
  composer.hidden = false
  const rr = rel(range.getBoundingClientRect())
  const cw = composer.offsetWidth, ch = composer.offsetHeight, sw = stage.clientWidth
  // Comme dans l'app : l'angle bas-droit du composer tombe sur le centre du passage (borné dans la zone).
  composer.style.left = Math.min(sw, Math.max(rr.x + rr.w / 2, cw + 4)) + 'px'
  composer.style.top = Math.max(rr.y + rr.h / 2, ch + 4) + 'px'
  if (focus) input.focus({ preventScroll: true })
}
let clearTouch = () => {}
function closeComposer() { composer.hidden = true; pending = null; clearTouch() }
/* Clavier mobile : une fois la zone visible réduite, on recale le composer et le passage juste en dessous. */
function keepInView() {
  if (composer.hidden || !pending) return
  const vv = window.visualViewport
  const top = composer.getBoundingClientRect().top
  const bottom = pending.getBoundingClientRect().bottom
  const viewTop = vv ? vv.offsetTop : 0, viewH = vv ? vv.height : innerHeight
  if (top < viewTop + 8 || bottom > viewTop + viewH - 8) scrollBy({ top: top - viewTop - 12, behavior: 'smooth' })
}
if (window.visualViewport) visualViewport.addEventListener('resize', () => setTimeout(keepInView, 60))
input.addEventListener('focus', () => setTimeout(keepInView, 350))

function placeBubble(t) {
  const r = t.span.getClientRects()[0]; if (!r) return
  const rr = rel(r)
  t.bubble.style.left = rr.x + rr.w / 2 + 'px'
  t.bubble.style.top = rr.y + rr.h / 2 + 'px'
}
addEventListener('resize', () => threads.forEach(placeBubble))

function msgEl(who, color, initial, html, meta) {
  const d = document.createElement('div'); d.className = 'msg'
  d.innerHTML = `<span class="av" style="background:${color}">${initial}</span><div><div class="who">${who}<span>${meta}</span></div><div class="b">${html}</div></div>`
  return d
}
function flash(t) { t.el.classList.add('flash'); t.span.classList.add('hot'); setTimeout(() => { t.el.classList.remove('flash'); t.span.classList.remove('hot') }, 900) }

async function submit(text, forClaude, reply) {
  const r = pending
  // Jamais de commentaire hors de la carte (ex. sélection restée dans le formulaire bêta).
  if (!r || r.collapsed || !desc.contains(r.commonAncestorContainer)) { closeComposer(); return }
  const span = document.createElement('span'); span.className = 'cmt-hl fresh'
  r.surroundContents(span)
  getSelection().removeAllRanges(); clearTouch()
  closeComposer()
  const bubble = document.createElement('button'); bubble.className = 'cbubble'; bubble.type = 'button'
  bubble.setAttribute('aria-label', 'Ouvrir le fil de commentaires')
  stage.appendChild(bubble)
  $('#cm-empty')?.remove()
  const el = document.createElement('div'); el.className = 'thread'
  el.innerHTML = `<div class="tquote">« ${esc(span.textContent.trim())} »</div>`
  el.appendChild(msgEl('Vous', 'var(--sc-primary)', 'V', esc(text).replace(/@Claude/g, '<span class="at">@Claude</span>'), 'à l’instant'))
  list.prepend(el); list.scrollTop = 0
  const t = { span, bubble, el }
  threads.push(t); placeBubble(t)
  $('#cm-count').textContent = threads.length
  bubble.onclick = () => { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); flash(t) }
  span.onclick = bubble.onclick
  if (!forClaude) { note.textContent = 'Commentaire déposé. Cochez @Claude pour que l’IA réponde.'; return t }
  note.textContent = ''
  await sleep(700)
  const typing = msgEl('Claude', 'var(--sc-violet)', 'C', '<span class="typing"><i></i><i></i><i></i></span>', 'lit le fil via MCP')
  el.appendChild(typing)
  await sleep(1500)
  const [answer, act] = reply || REPLIES[replyIx++ % REPLIES.length]
  typing.remove()
  const m = msgEl('Claude', 'var(--sc-violet)', 'C', '', 'via MCP')
  el.appendChild(m)
  const b = m.querySelector('.b')
  for (const w of answer.split(/(\s+)/)) { b.textContent += w; await sleep(32) }
  const chip = document.createElement('span'); chip.className = 'act'; chip.textContent = '✓ ' + act
  b.after(chip)
  bubble.textContent = '2'
  return t
}

input.addEventListener('input', () => (send.disabled = !input.value.trim()))
input.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (input.value.trim()) submit(input.value.trim(), fc.checked) }
  if (e.key === 'Escape') { e.preventDefault(); closeComposer() }
})
send.onclick = () => input.value.trim() && submit(input.value.trim(), fc.checked)
$('#cm-cancel').onclick = closeComposer
document.addEventListener('pointerdown', (e) => {
  // La démo s'arrête dès que le visiteur agit : dans la description, ou n'importe où hors de la zone de démo.
  if (demoOn && (desc.contains(e.target) || !stage.contains(e.target))) stopDemo()
  if (!composer.hidden && !composer.contains(e.target) && !demoOn && !(coarse && desc.contains(e.target))) closeComposer()
})
function trySelection() {
  if (demoOn) return
  const sel = getSelection()
  if (!sel.rangeCount || sel.isCollapsed) return
  const r = sel.getRangeAt(0)
  if (!desc.contains(r.commonAncestorContainer)) return
  const c = clampRange(r.cloneRange())
  if (!c) { note.textContent = 'Sélectionnez un passage dans une seule ligne, hors texte déjà commenté.'; return }
  note.textContent = ''
  openComposer(c)
}
desc.addEventListener('mouseup', () => { if (!coarse) setTimeout(trySelection, 10) })
desc.addEventListener('keyup', (e) => { if (e.shiftKey) trySelection() })
/* Mobile : le menu natif copier/coller ne se désactive pas sans couper la sélection. On la remplace :
   toucher un mot le sélectionne, glisser le doigt le long de la ligne étend la sélection mot par mot. */
if (coarse) {
  desc.classList.add('touchsel')
  document.querySelector('.try').lastChild.textContent = 'À vous : touchez un mot ou glissez le doigt sur une ligne'
  const marks = []
  let tsel = null, anchor = null, pid = null
  const isWord = (ch) => /[\p{L}\p{N}’'-]/u.test(ch)
  const caretAt = (x, y) => {
    if (document.caretPositionFromPoint) { const c = document.caretPositionFromPoint(x, y); return c && { node: c.offsetNode, off: c.offset } }
    if (document.caretRangeFromPoint) { const r = document.caretRangeFromPoint(x, y); return r && { node: r.startContainer, off: r.startOffset } }
    return null
  }
  const wordAt = (node, off) => {
    const t = node.data; let a = off, b = off
    while (a > 0 && isWord(t[a - 1])) a--
    while (b < t.length && isWord(t[b])) b++
    return a < b ? [a, b] : null
  }
  clearTouch = () => { marks.splice(0).forEach((m) => m.remove()) }
  const paint = () => {
    clearTouch()
    const r = document.createRange(); r.setStart(tsel.node, tsel.a); r.setEnd(tsel.node, tsel.b)
    for (const q of r.getClientRects()) {
      const m = document.createElement('div'); m.className = 'tsel'; const rr = rel(q)
      Object.assign(m.style, { left: rr.x + 'px', top: rr.y + 'px', width: rr.w + 'px', height: rr.h + 'px' })
      stage.appendChild(m); marks.push(m)
    }
    return r
  }
  desc.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' || demoOn) return
    const c = caretAt(e.clientX, e.clientY)
    if (!c || c.node.nodeType !== 3 || !desc.contains(c.node) || c.node.parentElement.closest('.cmt-hl')) return
    const w = wordAt(c.node, c.off); if (!w) return
    anchor = { node: c.node, a: w[0], b: w[1] }; tsel = { ...anchor }; pid = e.pointerId; paint()
  })
  desc.addEventListener('pointermove', (e) => {
    if (e.pointerId !== pid || !anchor) return
    const c = caretAt(e.clientX, e.clientY); if (!c || c.node !== anchor.node) return
    const w = wordAt(c.node, c.off); if (!w) return
    tsel = { node: anchor.node, a: Math.min(anchor.a, w[0]), b: Math.max(anchor.b, w[1]) }; paint()
  })
  const end = (e) => {
    if (e.pointerId !== pid || !anchor) return
    pid = null; anchor = null
    if (e.type === 'pointercancel') { tsel = null; clearTouch(); return } // le doigt a fait défiler la page
    note.textContent = ''
    openComposer(paint())
  }
  desc.addEventListener('pointerup', end)
  desc.addEventListener('pointercancel', end)
}

/* ── Démo à l'arrivée : sélection simulée, bulle, réponse de Claude qui précise la règle ── */
function stopDemo() {
  demoTok++; demoOn = false; fcur.classList.add('off')
  // N'efface que la sélection simulée par la démo, jamais celle du visiteur ailleurs dans la page.
  const s = getSelection()
  if (s.rangeCount && desc.contains(s.getRangeAt(0).commonAncestorContainer)) s.removeAllRanges()
  closeComposer()
}
document.addEventListener('focusin', (e) => { if (demoOn && !composer.contains(e.target)) stopDemo() })
document.addEventListener('keydown', () => { if (demoOn) stopDemo() })
function cur(x, y, ms = 800) { fcur.style.transitionDuration = ms + 'ms'; fcur.style.transform = `translate(${x}px, ${y}px)`; if (!ms) fcur.getBoundingClientRect(); return sleep(ms) }
async function demo() {
  const tok = ++demoTok; demoOn = true
  const alive = () => { if (tok !== demoTok) throw 'stop' }
  try {
    const li = $('#cm-r1'), node = li.firstChild, phrase = 'par notification'
    const start = node && node.nodeType === 3 ? node.data.indexOf(phrase) : -1
    if (start < 0) return // texte modifié : pas de démo automatique
    const r = document.createRange()
    r.setStart(node, start); r.setEnd(node, start + 1)
    const a = rel(r.getBoundingClientRect())
    await cur(a.x + 60, a.y + 140, 0)
    fcur.classList.remove('off')
    await cur(a.x, a.y + a.h * 0.6, 900); alive()
    const sel = getSelection()
    for (let i = 1; i <= phrase.length; i++) {
      sel.setBaseAndExtent(node, start, node, start + i)
      const e = rel(sel.getRangeAt(0).getBoundingClientRect())
      fcur.style.transitionDuration = '60ms'; fcur.style.transform = `translate(${e.x + e.w}px, ${e.y + e.h * 0.6}px)`
      await sleep(55); alive()
    }
    await sleep(350); alive()
    // Plage construite ici : la sélection du document a pu changer (clic ou saisie ailleurs) pendant l'attente.
    const demoRange = document.createRange()
    demoRange.setStart(node, start); demoRange.setEnd(node, start + phrase.length)
    openComposer(demoRange, false)
    const box = rel(input.getBoundingClientRect())
    await cur(box.x + 30, box.y + 14, 700); alive()
    for (const ch of USER_DEMO) { input.value += ch; await sleep(28); alive() }
    send.disabled = false
    const sb = rel(send.getBoundingClientRect())
    await cur(sb.x + sb.w / 2, sb.y + sb.h / 2, 650); alive()
    send.classList.add('press'); await sleep(160); send.classList.remove('press')
    fcur.classList.add('off')
    demoOn = false
    const t = await submit(USER_DEMO, true, CLAUDE_DEMO)
    // Claude ajuste la spec : la règle se précise sous les yeux du visiteur.
    if (t && desc.contains(t.span)) {
      const add = document.createElement('span'); add.className = 'added'; add.textContent = ' push, email en secours'
      t.span.after(add)
    }
  } catch (e) { if (e !== 'stop') throw e }
  finally { if (tok === demoTok) { demoOn = false; fcur.classList.add('off') } }
}
// La démo attend la fin de la transition depuis le terminal (la section est alors encore sous le calque).
let played = false, seen = false
const maybeDemo = () => { if (seen && !played && document.body.dataset.xfer !== '1') { played = true; setTimeout(demo, 350) } }
new IntersectionObserver(([e]) => { seen = e.isIntersecting; maybeDemo() }, { threshold: 0.45 }).observe(stage)
addEventListener('xfer-done', maybeDemo)
})()

/* ═════════════ WISHLIST : la candidature devient une carte qui rejoint la liste prioritaire de la bêta ═════════════ */
;(() => {
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches
const $ = (s) => document.querySelector(s)
const sleep = (ms) => new Promise((r) => setTimeout(r, reduce ? 0 : ms))
const form = $('#wform')
if (!form) return
const grid = $('#wl-grid'), cur = $('#wl-cursor'), tag = $('#wl-tag')
const slot = $('#bslot'), bmod = $('#bmod'), root = $('#beta00')
const f = { first: $('#wl-first'), last: $('#wl-last'), email: $('#wl-email'), status: $('#wl-status'), consent: $('#wl-consent') }
const CHECK = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>'
let busy = false, card = null, edgeSvg = null
const startedAt = Date.now()
/* La carte en vol est hors de la section : on la place dans un conteneur .scp pour garder ses styles. */
let host = null
const flyHost = () => { if (!host) { host = document.createElement('div'); host.className = 'scp scp-fly'; document.body.appendChild(host) } return host }
/* Branchement backend : champ « URL de l'API de candidature » du bloc (attribut data-api de la section).
   Sans URL, la candidature est simulée. Réponse du backend : 202 dans tous les cas valides. */
const API = document.getElementById('wishlist').dataset.api || ''
/* Conversion SEA : seulement quand le backend accepte réellement la candidature (202), jamais en mode
   simulé ni au simple clic. Aucune donnée personnelle dans l'événement. Le module de consentement
   (fin de fichier) écoute « scopenod:beta_application » pour les balises publicitaires. */
function trackApplication() {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'beta_application' })
  dispatchEvent(new Event('scopenod:beta_application'))
}
async function apply(d) {
  if (!API) { await sleep(900); return { ok: true } }
  try {
    const res = await fetch(API.replace(/\/$/, '') + '/api/beta/apply', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: d.email, firstName: d.first, lastName: d.last, jobStatus: d.status, consent: true, website: $('#wl-website').value, startedAt }),
    })
    if (res.status === 202) { trackApplication(); return { ok: true } }
    if (res.ok) return { ok: true }
    if (res.status === 429) return { ok: false, msg: 'Trop de tentatives depuis votre connexion. Réessayez dans quelques minutes.' }
    if (res.status === 400) return { ok: false, msg: 'Certaines informations sont invalides. Vérifiez le formulaire.' }
    return { ok: false, msg: 'Le service est momentanément indisponible. Réessayez un peu plus tard.' }
  } catch { return { ok: false, msg: 'Connexion impossible. Vérifiez votre réseau puis réessayez.' } }
}

function setErr(el, msg) {
  const fl = el.closest('.field'); fl.classList.toggle('bad', !!msg); fl.querySelector('.err').textContent = msg || ''
  el.setAttribute('aria-invalid', msg ? 'true' : 'false')
}
function validate() {
  const bad = []
  const chk = (el, ok, msg) => { setErr(el, ok ? '' : msg); if (!ok) bad.push(el) }
  chk(f.first, f.first.value.trim().length > 0, 'Indiquez votre prénom.')
  chk(f.last, f.last.value.trim().length > 0, 'Indiquez votre nom.')
  chk(f.email, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.value.trim()), 'Adresse email invalide (ex. vous@exemple.fr).')
  chk(f.status, !!f.status.value, 'Choisissez votre statut.')
  // Erreur de la case aussi en texte (pas seulement en rouge) : RGAA 3.1 / WCAG 1.4.1.
  $('#wl-consent-l').classList.toggle('bad', !f.consent.checked)
  $('#wl-consent-err').textContent = f.consent.checked ? '' : 'Cochez cette case pour envoyer votre candidature.'
  f.consent.setAttribute('aria-invalid', f.consent.checked ? 'false' : 'true')
  if (!f.consent.checked) bad.push(f.consent)
  if (bad.length) bad[0].focus()
  return !bad.length
}
for (const el of [f.first, f.last, f.email, f.status]) el.addEventListener('input', () => el.closest('.field').classList.contains('bad') && setErr(el, ''))
f.consent.addEventListener('change', () => { $('#wl-consent-l').classList.remove('bad'); $('#wl-consent-err').textContent = ''; f.consent.setAttribute('aria-invalid', 'false') })

const rel = (r) => { const g = grid.getBoundingClientRect(); return { x: r.left - g.left, y: r.top - g.top, w: r.width, h: r.height } }
function moveCur(x, y, ms = 800) { cur.style.transitionDuration = (reduce ? 0 : ms) + 'ms'; cur.style.transform = `translate(${x}px, ${y}px)`; if (!ms) cur.getBoundingClientRect(); return sleep(ms) }
const initials = (a, b) => (a.trim()[0] + b.trim()[0]).normalize('NFD').replace(/\p{M}/gu, '').toUpperCase().replace(/[^A-Z]/g, 'X')

function makeCard(code, status) {
  const el = document.createElement('div'); el.className = 'bcard'
  el.innerHTML = `<div class="row"><span class="lot">L1</span><span class="code">${code}</span><span class="chip"></span></div>
    <div class="t"></div>
    <div class="f">Suivi <span class="status st-idee">Reçue</span></div>
    <ul class="steps"><li><span class="box">${CHECK}</span>Candidature reçue</li><li><span class="box">${CHECK}</span>Email confirmé</li><li><span class="box">${CHECK}</span>Accès bêta envoyé</li></ul>`
  el.querySelector('.chip').textContent = status
  return el
}
function drawEdge(animate) {
  edgeSvg?.remove()
  if (!card) return
  const b = bmod.getBoundingClientRect(), r = root.getBoundingClientRect(), c = card.getBoundingClientRect()
  const x1 = c.left - b.left + 40, y1 = c.top - b.top, x2 = r.left - b.left + 40, y2 = r.bottom - b.top
  edgeSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  edgeSvg.setAttribute('class', 'bedge'); edgeSvg.setAttribute('width', b.width); edgeSvg.setAttribute('height', b.height)
  const p = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  p.setAttribute('d', `M${x1} ${y1} L${x2} ${y2}`)
  edgeSvg.appendChild(p); bmod.appendChild(edgeSvg)
  if (!animate || reduce) { p.style.strokeDasharray = '5 5'; return }
  const L = p.getTotalLength()
  p.style.strokeDasharray = L; p.style.strokeDashoffset = L; p.getBoundingClientRect()
  p.style.transition = 'stroke-dashoffset .7s cubic-bezier(.4,0,.2,1)'; p.style.strokeDashoffset = 0
  setTimeout(() => { p.style.transition = 'none'; p.style.strokeDasharray = '5 5' }, 720)
}
addEventListener('resize', () => drawEdge(false))

async function enroll() {
  busy = true
  $('#wl-error').textContent = ''
  const d = { first: f.first.value.trim(), last: f.last.value.trim(), email: f.email.value.trim(), status: f.status.value }
  const req = apply(d) // la requête part tout de suite ; l'animation attend sa réponse avant l'envol
  const code = 'BETA-' + initials(d.first, d.last)
  const name = d.first + ' ' + d.last
  // 1. Claude arrive sur la candidature
  const sb = rel($('#wl-submit').getBoundingClientRect())
  await moveCur(sb.x + sb.w * 0.7, sb.y + sb.h + 30, 0)
  cur.classList.remove('off'); tag.textContent = 'Claude · Lecture de la candidature…'
  const fr = rel(form.getBoundingClientRect())
  await moveCur(fr.x + fr.w * 0.62, fr.y + 26, 800)
  form.style.setProperty('--ac', 'var(--sc-claude)'); form.classList.add('writing')
  await sleep(450)
  // 2. le formulaire se replie à la taille d'une carte de fonctionnalité
  card = makeCard(code, d.status)
  card.classList.add('flycard'); card.style.visibility = 'hidden'
  const r0 = form.getBoundingClientRect()
  Object.assign(card.style, { left: r0.left + 'px', top: r0.top + 'px', width: r0.width + 'px' })
  flyHost().appendChild(card)
  const hc = card.offsetHeight
  form.style.height = form.offsetHeight + 'px'; form.getBoundingClientRect()
  form.classList.add('collapsing'); form.style.height = hc + 'px'
  tag.textContent = `Claude · create-feature ${code}`
  await sleep(600)
  // la carte prend le relais exactement à la place du formulaire replié
  const r1 = form.getBoundingClientRect()
  Object.assign(card.style, { left: r1.left + 'px', top: r1.top + 'px', width: r1.width + 'px', visibility: '' })
  form.style.visibility = 'hidden'
  const t = card.querySelector('.t')
  for (const ch of name) { t.textContent += ch; await sleep(38) }
  await sleep(250)
  const res = await req
  if (!res.ok) {
    // échec : la carte disparaît, le formulaire se redéplie avec le message
    card.remove(); card = null
    form.style.visibility = ''; form.classList.remove('collapsing', 'writing'); form.style.height = ''
    $('#wl-error').textContent = res.msg
    tag.textContent = 'Claude · échec'
    setTimeout(() => cur.classList.add('off'), 1200)
    busy = false
    return
  }
  // 3. sur mobile la liste est plus bas : on l'amène à l'écran avant l'envol
  if (innerWidth <= 900) { bmod.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); await sleep(650) }
  const a = card.getBoundingClientRect(), b = slot.getBoundingClientRect()
  const tb = rel(b)
  tag.textContent = 'Claude · ajout à la liste prioritaire'
  moveCur(tb.x + tb.w * 0.6, tb.y + 30, 900)
  if (!reduce) {
    await card.animate(
      [{ left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', transform: 'rotate(0deg)' },
       { left: (a.left + b.left) / 2 + 'px', top: Math.min(a.top, b.top) - 30 + 'px', width: (a.width + b.width) / 2 + 'px', transform: 'rotate(-2.5deg)', offset: 0.5 },
       { left: b.left + 'px', top: b.top + 'px', width: b.width + 'px', transform: 'rotate(0deg)' }],
      { duration: 950, easing: 'cubic-bezier(.65,0,.25,1)', fill: 'forwards' }).finished
  }
  // 4. atterrissage : la carte rejoint le module, se relie à BETA-00, son suivi avance
  card.getAnimations().forEach((x) => x.cancel())
  card.classList.remove('flycard'); card.removeAttribute('style'); card.classList.add('landed')
  slot.classList.add('filled'); slot.textContent = ''; slot.appendChild(card)
  $('#bmod-n').textContent = '1'
  drawEdge(true)
  await sleep(500)
  card.querySelector('.steps li').classList.add('ok')
  await sleep(400)
  const st = card.querySelector('.status'); st.className = 'status st-dev'; st.textContent = 'Email à confirmer'
  const log = document.createElement('span'); log.className = 'wlog'
  log.textContent = `✓ apply_ops · create-feature ${code} · link ${code} → BETA-00`
  $('#wlog-slot').appendChild(log); requestAnimationFrame(() => log.classList.add('on'))
  // 5. le formulaire devient la confirmation
  $('#wf-fields').hidden = true; $('#wf-done').hidden = false
  $('#wd-title').textContent = `Presque fini, ${d.first} !`
  $('#wd-email').textContent = d.email
  form.classList.remove('writing')
  form.style.height = form.offsetHeight + 'px'
  form.style.visibility = ''
  form.classList.remove('collapsing')
  form.style.height = $('#wf-done').offsetHeight + 40 + 'px'
  setTimeout(() => (form.style.height = ''), 600)
  tag.textContent = 'Claude · terminé'
  await sleep(1400)
  cur.classList.add('off')
  busy = false
}

form.addEventListener('submit', (e) => { e.preventDefault(); if (!busy && validate()) enroll() })
$('#wd-again').onclick = () => {
  // Modifier : on retire la carte de la liste et on rouvre le formulaire, valeurs conservées.
  card?.remove(); card = null; edgeSvg?.remove(); edgeSvg = null
  slot.classList.remove('filled'); slot.textContent = 'Votre place'
  $('#bmod-n').textContent = '0'; $('#wlog-slot').innerHTML = ''
  $('#wf-done').hidden = true; $('#wf-fields').hidden = false
  f.first.focus()
}
})()

;(() => {
/* ═════════════ VIDÉO : lecteur YouTube chargé au clic (façon lite-youtube) ═════════════ */
const player = document.querySelector('.vid-player[data-yt]')
if (!player) return
// Aucune requête vers YouTube ou Google avant le clic (ni miniature i.ytimg.com, ni préconnexion au survol) :
// l'adresse IP du visiteur ne part chez Google que s'il lance la vidéo (mention sous le lecteur).
// Image d'aperçu (facultative, hébergée sur le site) introuvable : fond uni plutôt qu'une image cassée.
player.querySelector('.vid-poster')?.addEventListener('error', (e) => { e.target.hidden = true })
player.querySelector('.vid-play').addEventListener('click', () => {
  const f = document.createElement('iframe')
  f.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(player.dataset.yt)}?autoplay=1&rel=0&modestbranding=1&playsinline=1`
  f.title = player.dataset.title || 'Vidéo'
  f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
  f.allowFullscreen = true
  player.replaceChildren(f)
  f.focus()
})
})()

;(() => {
/* ═════════════ SECTIONS À RÉVÉLER : .in posé une fois, à l'arrivée à l'écran ═════════════ */
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches
const els = document.querySelectorAll('[data-scp-reveal]')
if (!els.length) return
/** PB-01 : la même règle prend une valeur différente dans chaque source. */
function diverge(root) {
  root.querySelectorAll('.pb-src b[data-v]').forEach((b, i) => {
    const apply = () => { b.textContent = b.dataset.v; if (i > 0) b.classList.add('diff') }
    if (reduce) apply(); else setTimeout(apply, 500 + i * 450)
  })
}
const show = (el) => { el.classList.add('in'); diverge(el) }
if (reduce || !('IntersectionObserver' in window)) { els.forEach(show); return }
const io = new IntersectionObserver((entries) => {
  for (const e of entries) if (e.isIntersecting) { show(e.target); io.unobserve(e.target) }
}, { threshold: 0.3 })
els.forEach((el) => io.observe(el))
})()

;(() => {
/* ═════════════ GUIDE : bouton « Copier » d'un bloc de texte (data-scp-copy = id du bloc) ═════════════ */
document.querySelectorAll('[data-scp-copy]').forEach((btn) => {
  const src = document.getElementById(btn.dataset.scpCopy)
  if (!src || !navigator.clipboard) { btn.hidden = true; return }
  const label = btn.textContent
  btn.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(src.textContent); btn.textContent = 'Copié' }
    catch { btn.textContent = 'Copie impossible : sélectionnez le texte' }
    setTimeout(() => (btn.textContent = label), 2000)
  })
})
})()

;(() => {
/* ═════════════ UTM : paramètres de campagne de la page en cours ═════════════
   Lus dans l'URL de la page, sans rien écrire dans le navigateur (ni cookie, ni sessionStorage) :
   stocker l'origine d'une visite sur le terminal du visiteur est un traceur au sens de la CNIL.
   Seulement utm_* (pas d'identifiant de clic gclid / msclkid). Lecture :
   window.scopenodUtm() → { utm_source, utm_campaign, … } ou {} ; à transmettre avec la candidature
   quand le backend l'acceptera (champ signupSource). Les liens de campagne doivent donc pointer
   directement vers la page du formulaire (accueil). */
const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
window.scopenodUtm = () => {
  const q = new URLSearchParams(location.search), utm = {}
  for (const k of KEYS) { const v = q.get(k); if (v) utm[k] = v.slice(0, 200) }
  return utm
}
})()

;(() => {
/* ═════════════ CONSENTEMENT PUBLICITAIRE (inc/consent.php) ═════════════
   Absent de la page tant que la bannière n'est pas activée dans l'admin. Aucune balise avant
   « Accepter », et seulement pour les identifiants renseignés (window.scopenodAds). */
const banner = document.getElementById('scp-consent')
const ads = window.scopenodAds
if (!banner || !ads) return
const STORE = 'scp_consent', MAX_AGE = 1000 * 60 * 60 * 24 * 182 // choix gardé 6 mois
const read = () => {
  try {
    const c = JSON.parse(localStorage.getItem(STORE) || 'null')
    return c && (c.v === 'granted' || c.v === 'denied') && Date.now() - c.t < MAX_AGE ? c.v : null
  } catch { return null }
}
const save = (v) => { try { localStorage.setItem(STORE, JSON.stringify({ v, t: Date.now() })) } catch { /* choix valable pour cette page seulement */ } }
const gtag = (...a) => window.gtag && window.gtag(...a)
const addScript = (src) => { const s = document.createElement('script'); s.async = true; s.src = src; document.head.appendChild(s) }
let loaded = false
function loadTags() {
  if (loaded) return
  loaded = true
  const google = ads.google || (ads.conversion && ads.conversion.split('/')[0])
  if (google) { addScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(google)); gtag('js', new Date()); gtag('config', google) }
  if (ads.uet) {
    window.uetq = window.uetq || []
    const s = document.createElement('script'); s.async = true; s.src = 'https://bat.bing.com/bat.js'
    s.onload = () => { const q = window.uetq; window.uetq = new window.UET({ ti: ads.uet, q, enableAutoSpaTracking: false }); window.uetq.push('pageLoad') }
    document.head.appendChild(s)
  }
}
function apply(v) {
  const state = v === 'granted' ? 'granted' : 'denied'
  gtag('consent', 'update', { ad_storage: state, ad_user_data: state, ad_personalization: state })
  window.uetq = window.uetq || []; window.uetq.push('consent', 'update', { ad_storage: state })
  if (state === 'granted') loadTags()
}
function choose(v) {
  const before = read()
  save(v); banner.hidden = true
  if (v === 'denied' && before === 'granted') {
    // Retrait du consentement : suppression des cookies publicitaires posés sur ce domaine, puis rechargement
    for (const name of document.cookie.split(';').map((c) => c.split('=')[0].trim())) {
      if (!/^(_gcl_|_gac_|_uetsid|_uetvid)/.test(name)) continue
      // Google et Microsoft posent le cookie sur le domaine parent (justhugo.fr) : on essaie chaque niveau
      const parts = location.hostname.split('.')
      document.cookie = name + '=; Max-Age=0; path=/'
      for (let i = 0; i < parts.length - 1; i++) document.cookie = name + '=; Max-Age=0; path=/; domain=.' + parts.slice(i).join('.')
    }
    location.reload(); return
  }
  apply(v)
}
banner.querySelectorAll('[data-scp-consent]').forEach((b) => b.addEventListener('click', () => choose(b.dataset.scpConsent)))
document.querySelectorAll('[data-scp-consent-open]').forEach((b) => b.addEventListener('click', () => { banner.hidden = false; banner.querySelector('[data-scp-consent]').focus() }))
const current = read()
if (current) apply(current); else banner.hidden = false
// Conversion : candidature acceptée par l'API (événement émis par le module bêta), avec consentement seulement
addEventListener('scopenod:beta_application', () => {
  if (read() !== 'granted') return
  if (ads.conversion) gtag('event', 'conversion', { send_to: ads.conversion })
  if (ads.uet && window.uetq) window.uetq.push('event', 'beta_application', {})
})
})()
